// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-item__error[data-v-1239d2bc]{font-size:.85rem;color:#f71f40;text-align:left;opacity:.9}.form-item__error__inner[data-v-1239d2bc]{padding-top:.5rem}", ""]);
// Exports
module.exports = exports;
